import { createContext, useContext } from 'react'
import type { UploadManagerContextValue } from '@/shared/domain'

export const UploadManagerContext = createContext<UploadManagerContextValue | null>(null)

export function useUploadManager(): UploadManagerContextValue {
  const ctx = useContext(UploadManagerContext)
  if (!ctx) {
    throw new Error('useUploadManager must be used within an UploadManagerProvider')
  }
  return ctx
}
